import { defineMessages } from 'react-intl';

export default defineMessages({
  loadMore: {
    description: 'button label to load more user activity',
    defaultMessage: 'Load More',
    id: '3ZAGFP',
  },
  noActivity: {
    description: 'shown when no user activity is displayable',
    defaultMessage: 'No user activity found.',
    id: 'ZY/cOS',
  },
});
